import type { SVGProps } from 'react';

const SvgPlusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path fill={props.color} d="M25.07 19.1v-2.16h-6V11h-2.15v6h-6v2.1h6v5.95h2.16V19.1Z" />
    <path
      fill={props.color}
      d="M18 36a18 18 0 1 1 18-18 18 18 0 0 1-18 18m0-34a16 16 0 1 0 16 16A16 16 0 0 0 18 2"
    />
  </svg>
);

export default SvgPlusCircle;
